import { useCallback, useRef } from 'react';

export const useStateChangeGuard = <T extends string>(): ((
  nextState: T,
) => boolean) => {
  const ref = useRef<T | undefined>(undefined);

  return useCallback((nextState) => {
    const isDifferent =
      typeof ref.current === 'undefined' || nextState !== ref.current;

    ref.current = nextState;

    return isDifferent;
  }, []);
};
